<template>
    <div v-if="toggle" class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0  bg-gray-800 bg-opacity-50 "></div>
        <div class="fixed inset-0 z-10 overflow-y-auto">
            <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                <div
                    class="relative bg-white px-10 transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" :class="containerClass">
                    <div class="">
                        <div class="sm:flex sm:items-start">
                            <div class="w-full text-center">
                                <div class="relative flex items-center justify-center py-8">
                                    <p class="text-xl font-medium leading-6 text-gray-900 text-left" id="modal-title">
                                        <slot name="header"></slot>
                                    </p>
                                    <button @click="action('cancel', true)"
                                        class="absolute right-0 rounded p-1.5 bg-[#F8F8F8] hover:bg-[#F0F0F0] ease-linear transition-all duration-150">
                                        <IconClose></IconClose>
                                    </button>
                                </div>
                                <div class="pt-6 pb-10 border-t border-solid border-[#F5F5F5]">
                                    <slot name="content"></slot>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class=" sm:flex sm:flex-row-reverse">
                        <button v-if="acceptBtn === true" @click="action('accept', true)" type="button"
                            class="inline-flex w-full justify-center rounded-md bg-kb-yellow px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-600 sm:ml-3 sm:w-auto">{{
                               acceptText || $t('modal.yes') }}</button>
                        <button @click="action('cancel', true)" type="button"
                            class="mt-3 inline-flex w-full justify-center rounded-md   px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-slate-300 sm:mt-0 sm:w-auto">{{
                                cancelText || $t('modal.no') }}</button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import IconClose from '@icons/IconClose.vue';
import { ref, watch } from 'vue'
let props = defineProps({
    containerClass: {
        type: String,
        default: ''
    },
    showModal: {
        type: Boolean,
        default: false,
    },
    cancelText: {
        type: String,
        default: ''
    },
    acceptText: {
        type: String,
        default: ''
    },
    acceptBtn: {
        type: Boolean,
        default: true
    }
})
let toggle = ref(false)

watch(() => props.showModal, (newValue, oldValue) => {
    toggle.value = newValue
})

toggle.value = props.showModal

const emit = defineEmits(['accept', 'cancel'])

let action = (action, payload) => {
    emit(action, payload)
}

</script>